import { Post } from "./helpers";

export const ValidateCss = async (css: string): Promise<any> => {
	return Post('/v3/admin/events/css-validate', '', { css }, false, {}, true)
		.then(async res => {
			if (res.ok) {
				return await res.json();
			}

			return { error: res.status };
		}).catch(e => ({ error: e }));
};
